<template>
  <v-row no-gutters>
    <v-col cols="12" sm="10" offset-sm="1">
      <span class="headline">Sve Ankete</span>
      <bit-pagae :breadcrumbs="breadcrumbs"></bit-pagae>
      <v-row align="center" class="white mt-3 pa-3" no-gutters>
        <v-col cols="12">

          <v-data-table
            :headers="headers"
            :items="items"
            sort-by="calories"
            class="elevation-1"
          >
            <template v-slot:top>
              <v-toolbar
                flat
              >
                <v-toolbar-title>Ankete</v-toolbar-title>
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-dialog
                  v-model="dialog"
                  max-width="500px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      class="mb-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      Nova Anketa
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="text-h5">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-tabs v-model="tab" background-color="primary" dark height="40">
                          <v-tab v-for="item in editedItem.langs" :key="item.tab">
                            {{ item.lang.name }}
                          </v-tab>
                        </v-tabs>

                        <v-tabs-items v-model="tab">
                          <v-tab-item v-for="item in editedItem.langs" :key="item.tab">
                            <v-col
                              cols="12"
                            >
                              <v-text-field
                                v-model="item.name"
                                label="Naziv"
                              ></v-text-field>
                            </v-col>
                          </v-tab-item>
                        </v-tabs-items>
                        <v-row class="px-4">
                          <v-col
                            cols="12"
                          >
                            <v-text-field
                              v-model="editedItem.survey_id"
                              label="ID Ankete"
                              type="number"
                              hint="Integracija sa eankete.com"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                          >
                            <v-text-field
                              v-model="editedItem.tag"
                              label="Tag"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                          >
                            <v-text-field
                              v-model="editedItem.position"
                              label="Sort"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="close"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="save"
                      >
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                      <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="editItem(item)"
              >
                mdi-pencil
              </v-icon>
<!--              <v-icon-->
<!--                small-->
<!--                @click="deleteItem(item)"-->
<!--              >-->
<!--                mdi-delete-->
<!--              </v-icon>-->
            </template>
          </v-data-table>

        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import bitPage from "../../components/layout/page";

export default {
  components: {
    bitPage
  },
  head() {
    return {
      title: 'BitLab CMS'
    }
  },
  data: () => ({
    breadcrumbs: [
      {
        text: 'Anketa',
        disabled: true
      },
    ],
    headers: [
      {text: 'ID', value: 'id'},
      {text: 'Name', value: 'name'},
      {text: 'ID Ankete', value: 'survey_id'},
      {text: 'Tag', value: 'tag'},
      {text: 'Sort', value: 'position'},
      {text: 'Actions', value: 'actions'}
    ],
    items: [],

    dialog: false,
    dialogDelete: false,
    editedIndex: -1,
    editedItem: {
      name: '',
      survey_id: 0,
      langs: [],
      position: 0,
      tag: ''
    },
    defaultItem: {
      name: '',
      survey_id: 0,
      langs: [],
      position: 0,
      tag: ''
    },
    tab: null
  }),
  created() {
    this.axios.get('/survey').then(res => {
      this.items = res.data
      this.getLangs()
    })

    this.$store.dispatch('GET_LANGUAGES').then(res => {
      res.forEach(lang => {
        let check = this.editedItem.langs.find(item => item.lang_id === lang.id)

        this.defaultItem.langs.push({
          name: null,
          lang: lang,
          lang_id: lang.id
        })
        if(!check) {
          this.editedItem.langs.push({
            name: null,
            lang: lang,
            lang_id: lang.id
          })
        }

      })
    })

  },
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },
    setLang() {
      return this.$store.state.lang.code === 'en'
        ? 'en' : this.$store.state.lang.code === 'la'
          ? 'sr' : 'ћи'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
  },

  methods: {
    getLangs() {
      this.$store.dispatch('GET_LANGUAGES').then(res => {

        res.forEach(lang => {

          this.items.forEach(item => {
            let check = item.langs.find(item => item.lang_id === lang.id)

            let lang2 =  item.langs.find(item => item.lang.lang_code === this.setLang);
            if(!item.name) item.name = lang2 && lang2.name ? lang2.name : '';

            if(!check) {
              item.langs.push({
                name: null,
                lang: lang,
                lang_id: lang.id
              })
            }
          })

        })

        console.log('this.items', this.items)

      })
    },

    editItem (item) {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      this.editedIndex = this.items.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },

    deleteItemConfirm () {
      this.items.splice(this.editedIndex, 1)
      this.closeDelete()
    },

    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    save () {
      let _this = this
      if (this.editedIndex > -1) {
        this.axios.put('/survey/' + this.editedItem.id, this.editedItem)
        Object.assign(this.items[this.editedIndex], this.editedItem)
      } else {
        this.axios.post('/survey', this.editedItem).then(res => {
          _this.items.push(res.data.data)
        })
      }
      this.close()
    }
  }
}
</script>
